import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FirestoreService } from 'src/app/services/firestore.service';

@Component({
  selector: 'app-store-product-list',
  templateUrl: './store-product-list.component.html',
  styleUrls: ['./store-product-list.component.sass']
})
export class StoreProductListComponent implements OnInit {
  logoImage: string = "./assets/img/no-logo.png"
  coverImage: string = "./assets/img/cover-ads.png"
  
  //storeproductDocId;
  storeproductCol;
  
  constructor(    
    private route: Router,
    private aroute: ActivatedRoute,
    public db: FirestoreService
  ) { }

  ngOnInit(): void {
    this.storeproductCol = this.db.getMainCol('storeproducts');
  };

  routeStoreProductDetailPage(docId){
    this.route.navigateByUrl('storeproduct/'+docId);
  }

}
